//import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import {observable, computed} from 'mobx';
import {Provider, Observer} from 'mobx-react';
import './index.css';
//import App from './App';
import {App} from './visual/view/App';

import {Messenger} from './view/Flasher/component';
import {PreventParentScroll} from './visual/component/PreventParentScroll';
//import registerServiceWorker from './registerServiceWorker';


import moment from 'moment';

import {build} from './integration';
import {getIn} from './utils';

//import {build as build2} from './integration02';

import {AllotmentCalendar} from './visual/component/AllotmentCalendar';
import { ConfirmationDialog } from './visual/component/ConfirmationDialog';

import {initTranslations} from './translate';
initTranslations();


window.__forceSmoothScrollPolyfill__ = true;
require('smoothscroll-polyfill');

const NEWCORE = false;

const orgId = getIn(window, ['ict', 'wyby', 'organizationId']);
if(orgId) {
  window.sessionStorage.clear();
  window.sessionStorage.setItem('orgId', orgId);
}

const app = build();

window.app = app;

if(!NEWCORE) {
  ReactDOM.render(
    <Provider app={app}>
    <div>
      <PreventParentScroll>{({ refScrollable, onScrollableWheel }) => <Observer>{() => 
        <div ref={refScrollable} onWheel={onScrollableWheel}>
          <Messenger />
          <ConfirmationDialog />
        </div>
      }</Observer>}</PreventParentScroll>
      <App />
    </div>
    </Provider>
  , document.getElementById('root')); 
  //registerServiceWorker();
}
else {

}

/*

ReactDOM.render(
  <AllotmentCalendar
    selectableAllotment={true}
    movableAllotment={true}
    observables={observable({
      selection: {
        start: computed(() => moment('2017-11-29 10:15')),
        end: computed(() => moment('2017-11-29 15:15')),
      }, 
      selected: {
        start: computed(() => moment('2017-11-29 11:15')),
        end: computed(() => moment('2017-11-29 17:15')),
      },
      updtItems: computed(() => [{start: moment('2017-11-28 09:00'), end: moment('2017-11-28 17:00')}]),
      alreadyRentItems: computed(() => [{start: moment('2017-11-27 07:00'), end: moment('2017-11-27 19:00')}]),
      defaultView: computed(() => 'agendaWeekOneDay'),
      defaultDate: computed(() => moment('2017-11-24 09:00')),
    })}
    onSelectionChanged={event => {
      //vOfferDetails.setSelection({start: event.start, end: event.end});
    }}
    onIntervalSelect={({start, end}) => {
      //vOfferDetails.setSelection({start, end});
    }}                      
  /> 
, document.getElementById('root'));

*/


// WEBPACK FOOTER //
// ./src/index.js